import apiFinanzas from './apiBase'

/**
 * Servicio para Presupuestos
 */
export const presupuestosServicio = {
  /**
   * Listar todos los presupuestos
   */
  async listar(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/presupuestos', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al listar presupuestos:', error)
      throw error
    }
  },

  /**
   * Obtener un presupuesto por ID
   */
  async obtener(id) {
    try {
      const response = await apiFinanzas.get(`/finanzas/presupuestos/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al obtener presupuesto:', error)
      throw error
    }
  },

  /**
   * Crear nuevo presupuesto
   */
  async crear(datos) {
    try {
      const response = await apiFinanzas.post('/finanzas/presupuestos', datos)
      return response.data || response
    } catch (error) {
      console.error('Error al crear presupuesto:', error)
      throw error
    }
  },

  /**
   * Actualizar presupuesto
   */
  async actualizar(id, datos) {
    try {
      const response = await apiFinanzas.put(`/finanzas/presupuestos/${id}`, datos)
      return response.data || response
    } catch (error) {
      console.error('Error al actualizar presupuesto:', error)
      throw error
    }
  },

  /**
   * Eliminar presupuesto
   */
  async eliminar(id) {
    try {
      const response = await apiFinanzas.delete(`/finanzas/presupuestos/${id}`)
      return response.data || response
    } catch (error) {
      console.error('Error al eliminar presupuesto:', error)
      throw error
    }
  },

  /**
   * Obtener comparativa de presupuesto vs real
   */
  async obtenerComparativa(params = {}) {
    try {
      const response = await apiFinanzas.get('/finanzas/presupuestos/comparativa/analisis', { params })
      return response.data || response
    } catch (error) {
      console.error('Error al obtener comparativa:', error)
      throw error
    }
  }
}

export default presupuestosServicio
